<template>
  <section id="card-text-alignment">
    <SearchComponent/>
    <ListComponent/>
  </section>
</template>

<script lang="ts">
import SearchComponent from "@/views/trendyol/export-supplier-product/Search.vue";
import ListComponent from "@/views/trendyol/export-supplier-product/List.vue"

export default {
  name: 'TrendyolExportSupplierProduct',
  components: {SearchComponent, ListComponent},
  created() {
    this.$store.dispatch('supplier/suppliers')
    this.$store.dispatch('store/stores')
  },
}
</script>

<style scoped>

</style>